import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

import { AuthProvider } from './context/AuthContext';
import { UploadProvider } from './context/UploadContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <UploadProvider>
      <App />
      </UploadProvider>
    </AuthProvider>
  </BrowserRouter>
);
